var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"inline-block"},[(_vm.order === 'asc')?_c('aha-icon',{staticClass:"transform rotate-180",attrs:{"name":"arrow","height":"12","width":"12","viewBox":"0 0 24 24"}}):_vm._e(),(_vm.order === 'desc')?_c('aha-icon',{attrs:{"name":"arrow","height":"12","width":"12","viewBox":"0 0 24 24"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }